import React, {
  FC,
  PropsWithChildren,
  ReactElement,
  Ref,
  forwardRef,
  memo,
} from 'react';

import { Dialog, Slide, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

import { modalActions } from '@contexts/common/ModalContext';

import closeIcon from '@assets/icons/modalArrow.svg?url';

import useStyles from './styles.module';

const Transition = forwardRef(
  (
    props: TransitionProps & {
      children: ReactElement;
    },
    ref: Ref<unknown>,
  ) => <Slide direction="up" ref={ref} {...props} />,
);

Transition.displayName = 'Transition';

interface Props extends PropsWithChildren {
  title?: string;
  onClose?: () => void;
  disableBackdropClick?: boolean;
  isHideCloseBtn?: boolean;
  classNameModal?: string;
  classNameChildren?: string;
}

const Popup: FC<Props> = ({
  children,
  title = '',
  onClose = undefined,
  disableBackdropClick = false,
  isHideCloseBtn = false,
  classNameModal,
  classNameChildren,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Dialog
      fullScreen
      open
      onClose={disableBackdropClick ? undefined : onClose || modalActions?.hide}
      TransitionComponent={Transition}
      className={classes.dialog}
    >
      <div className={cx(classes.modal, classNameModal)}>
        <div className={classes.headerModal}>
          {!isHideCloseBtn && (
            <button
              aria-label="close"
              className={classes.closeBtn}
              onClick={onClose || modalActions.hide}
            >
              <img src={closeIcon} alt="" />
            </button>
          )}
          {title && (
            <Typography
              variant="h4"
              color={(theme) => theme.palette.custom.text.light}
            >
              {title}
            </Typography>
          )}
        </div>
        <div className={cx(classes.children, classNameChildren)}>
          {children}
        </div>
      </div>
    </Dialog>
  );
};

export default memo(Popup);
